export default __webpack_public_path__ + "static/media/football-icon.40aec59b.svg";